import { getVersionFromUrl } from "./utils";

// 版本号存储键
export const VERSION_KEY = "F_VERSION";

export namespace VersionManager {
    /**
     * 保存版本号到sessionStorage
     * @param version 版本号
     */
    export function saveVersion(version: string) {
        if (typeof window === "undefined" || !version) {
            return;
        }
        sessionStorage.setItem(VERSION_KEY, version);
    }

    /**
     * 从sessionStorage获取版本号
     * @returns 版本号字符串，如果没有则返回空字符串
     */
    export function getVersion(): string {
        if (typeof window === "undefined") {
            return "";
        }
        try {
            return sessionStorage.getItem(VERSION_KEY) || "";
        } catch (err) {
            return "";
        }
    }

    /**
     * 清除版本号
     */
    export function clearVersion() {
        if (typeof window === "undefined") {
            return;
        }
        sessionStorage.removeItem(VERSION_KEY);
    }

    /**
     * 获取当前版本号（优先从URL获取，其次从sessionStorage获取）
     * @returns 版本号字符串
     */
    export function getCurrentVersion(): string {
        // 优先从URL获取
        const urlVersion = getVersionFromUrl();
        if (urlVersion) {
            return urlVersion;
        }

        // 其次从sessionStorage获取
        return getVersion();
    }
}
